module.exports = __webpack_public_path__ + "static/media/pic-ht5.de37a4a6.jpg";